var m = require('mithril');
var prop = require('mithril/stream');
var edit = require('../../layout/components/edit');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var modalForm = require('../../layout/components/modalForm');
var elementForm = modalForm(require('../models/element'));
var datasetForm = modalForm(require('../../data/models/dataset'));
var heading = require('../../components/heading');
var list = require('./list');
var bignumber = require('./bignumber');
var tridata = require('../../data/components/elementTriData')
var table = require('./table');
var schedule = require('./schedule');
var graphic = require('./graphic');
var chart = require('../../data/components/elementChart');
var chartwithpoint = require('./chartWithPoint');
var elementChartByUnits = require ('../../data/components/elementChartsByUnits');
var gauge = require('../../data/components/gaugeChart');
var gaugeAccum = require('../../data/components/gaugeChartDailyTotal');
var linearGauge = require('../../data/components/linearGauge');
var textElement = require('./textElement');
var smartTable = require('./smartTable');
var smartList = require('./smartList');
var smartChart = require('./smartChart');
var diagramElement = require('./diagramElement');
var datasetBuildingMode = require('../../equipment/datasetBuildingMode');
var helpModal = require('../../help/helpModal');

function collectSourceColumns(containsEdge) {
  if (!containsEdge || !containsEdge.in) return [];
  if (Array.isArray(containsEdge.in.out_Column)) return containsEdge.in.out_Column;
  if (!Array.isArray(containsEdge.in.out_Contains)) return [];

  var sourceDatasetEdge = containsEdge.in.out_Contains.find(function (edge) {
    return edge && edge.in && Array.isArray(edge.in.out_Column);
  });
  return sourceDatasetEdge ? sourceDatasetEdge.in.out_Column : [];
}

function mergeColumnPermissions(targetColumns, sourceColumns) {
  if (!Array.isArray(targetColumns) || !Array.isArray(sourceColumns) || sourceColumns.length === 0) return;

  var permissionByKey = {};
  sourceColumns.forEach(function (column) {
    if (!column || !column.permission) return;
    if (column['@rid']) permissionByKey[column['@rid']] = column.permission;
    if (column.in && column.in['@rid']) permissionByKey[column.in['@rid']] = column.permission;
    if (column.name) permissionByKey[column.name] = column.permission;
  });

  targetColumns.forEach(function (column) {
    if (!column || column.permission) return;
    column.permission = permissionByKey[column['@rid']] ||
      (column.in && permissionByKey[column.in['@rid']]) ||
      permissionByKey[column.name];
  });
}

function firstColumnPermission(columns) {
  var column = Array.isArray(columns)
    ? columns.find(function (record) { return record && record.permission; })
    : null;
  return column ? column.permission : undefined;
}

function responseStatus(error) {
  return error && (error.status || error.code || (error.response && error.response.status));
}

function shouldHideForbiddenElement(error) {
  return Number(responseStatus(error)) === 403 &&
    !(edit.vm && edit.vm.editing && edit.vm.editing());
}

function columnSignature(column) {
  return {
    rid: column && column['@rid'],
    id: column && column.id,
    index: column && column.index,
    name: column && column.name,
    unit: column && column.unit,
    type: column && column.type,
    pointRid: column && column.in && column.in['@rid']
  };
}

function getDatasetRecordFromChild(child) {
  var childRecord = child && child.in;
  var containsEdge = childRecord &&
    Array.isArray(childRecord.out_Contains) &&
    childRecord.out_Contains[0];
  return (containsEdge && containsEdge.in) || childRecord || {};
}

function getChildSignature(attrs) {
  attrs = attrs || {};
  var child = attrs.child || {};
  var childRecord = child.in || {};
  if (!attrs.datasetRepresentation) {
    return JSON.stringify({
      edgeRid: child['@rid'],
      recordRid: childRecord['@rid'],
      parentRid: attrs.parentRid
    });
  }

  var datasetRecord = getDatasetRecordFromChild(child);
  return JSON.stringify({
    edgeRid: child['@rid'],
    recordRid: datasetRecord['@rid'] || childRecord['@rid'],
    type: datasetRecord.type || childRecord.type,
    parentRid: attrs.parentRid,
    columns: (datasetRecord.columns || []).map(columnSignature),
    out_Column: (datasetRecord.out_Column || []).map(columnSignature)
  });
}

function handleElementLoadError(ctrl, error) {
  ctrl.loading = false;
  if (shouldHideForbiddenElement(error)) {
    ctrl.hidden = true;
    ctrl.error = null;
    return;
  }
  ctrl.hidden = false;
  ctrl.error = 'There was an error loading this Element';
}

function oninit (vnode) {
  var ctrl = this;
  ctrl.attrs = vnode.attrs;
  ctrl.containsEdge = vnode.attrs.child;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.OrMenuOptions = vnode.attrs.OrMenuOptions;
  ctrl.hidePreferredViewMenu = vnode.attrs.hidePreferredViewMenu;
  ctrl.record = prop({});
  ctrl.error = null;
  ctrl.hidden = false;
  ctrl.class = vnode.attrs.class;
  ctrl.datasetRepresentation = vnode.attrs.datasetRepresentation;
  ctrl.expandedCloseIconMargin = vnode.attrs.expandedCloseIconMargin;
  ctrl.childSignature = getChildSignature(vnode.attrs);
  // Dev-only error simulation controls (URL: ?simulateElementError[=rate])
  var isDevEnv = (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production');
  ctrl.simulateErrorEnabled = false;
  ctrl.simulateErrorRate = 0.5;
  try {
    if (isDevEnv) {
      // Standard query string (?key=value)
      var qs = (typeof window !== 'undefined' && window.location && window.location.search) ? window.location.search : '';
      if (qs && qs.indexOf('simulateElementError') !== -1) {
        ctrl.simulateErrorEnabled = true;
        var m = qs.match(/(?:\?|&)simulateElementError(?:=([^&]*))?/);
        if (m && typeof m[1] !== 'undefined' && m[1] !== null && m[1] !== '') {
          var r = parseFloat(decodeURIComponent(m[1]));
          if (!isNaN(r)) {
            ctrl.simulateErrorRate = Math.max(0, Math.min(1, r));
          }
        }
      }

      // Hashbang-style query inside the hash (#!/...?...)
      var hash = (typeof window !== 'undefined' && window.location && window.location.hash) ? window.location.hash : '';
      if (hash) {
        var qPos = hash.indexOf('?');
        if (qPos !== -1) {
          var hqs = hash.slice(qPos);
          if (hqs.indexOf('simulateElementError') !== -1) {
            ctrl.simulateErrorEnabled = true;
            var mh = hqs.match(/(?:\?|&)simulateElementError(?:=([^&]*))?/);
            if (mh && typeof mh[1] !== 'undefined' && mh[1] !== null && mh[1] !== '') {
              var rh = parseFloat(decodeURIComponent(mh[1]));
              if (!isNaN(rh)) {
                ctrl.simulateErrorRate = Math.max(0, Math.min(1, rh));
              }
            }
          }
        }
      }
    }
  } catch (e) {}
  
  ctrl.init = function () {
    var attrs = ctrl.attrs || {};
    ctrl.record({});
    ctrl.loading = true;
    ctrl.error = null;
    ctrl.hidden = false;
    // helper: maybe randomly fail a request for testing
    function maybeSimulate(promise) {
      if (!ctrl.simulateErrorEnabled) return promise;
      return promise.then(function (data) {
        if (Math.random() < ctrl.simulateErrorRate) {
          throw new Error('Simulated load error');
        }
        return data;
      });
    }

    if (ctrl.datasetRepresentation) {
      var req = loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/dataset/' + ctrl.containsEdge.in['@rid'].slice(1),
        method: 'GET'
      });
      req = maybeSimulate(req);
      return req
      .then(function (datasetRecord) {
        if (!datasetRecord) { throw new Error('Empty response'); }
        if (!datasetRecord.type) { datasetRecord.type = 'list'; }
        var sourceColumns = collectSourceColumns(ctrl.containsEdge);
        mergeColumnPermissions(datasetRecord.out_Column, sourceColumns);
        var inheritedPermission = ctrl.containsEdge.permission || datasetRecord.permission || firstColumnPermission(sourceColumns);
        
        let fakeElement = {
          ...datasetRecord,
          width: datasetRecord.width,
          '@rid': datasetRecord['@rid'],
          name: datasetRecord.name,
          type: datasetRecord.type,
          chartSpan: datasetRecord.chartSpan,
          chartResample: datasetRecord.chartResample,
          yMax: datasetRecord.yMax,
          yMin: datasetRecord.yMin,
          markdownText: datasetRecord.markdownText,
          src: datasetRecord.src,
          label: datasetRecord.label,
          dividerType: datasetRecord.dividerType,
          srcPath: datasetRecord.srcPath,
          out_Contains: [ { in: datasetRecord } ],
          parentRid: attrs.parentRid,
          parentName: attrs.parentName,
          showInSummary: datasetRecord.showInSummary,
          hideInDiagram: datasetRecord.hideInDiagram,
          hideInParentDiagram: datasetRecord.hideInParentDiagram,
          hideInEquipmentDetail: datasetRecord.hideInEquipmentDetail,
          hideInParentEquipmentDetail: datasetRecord.hideInParentEquipmentDetail,
          hideOnMap: datasetRecord.hideOnMap,
          height: datasetRecord.height,
          helpText: datasetRecord.helpText,
          location: attrs.location,
          permission: inheritedPermission,
          url: datasetRecord.url,
          permissionClasses: datasetRecord.permissionClasses,
          path: datasetRecord.path || [],
          datasetRepresentation: true
        }
        if (datasetRecord.in_Contains && 
          Array.isArray(datasetRecord.in_Contains) && 
          datasetRecord.in_Contains[0] &&
          datasetRecord.in_Contains[0].out
        ) {
          fakeElement.parent = datasetRecord.in_Contains[0].out;
        }
        ctrl.record(fakeElement);
        ctrl.loading = false;
      })
      .catch(function (error) {
        handleElementLoadError(ctrl, error);
      });
    } else {
      var reqEl = loaders.requestWithLoader({
        loader: 'main',
        url: '/api/v1/element/' + ctrl.containsEdge.in['@rid'].slice(1),
        method: 'GET'
      });
      reqEl = maybeSimulate(reqEl);
      return reqEl
      .then(function (elementRecord) {
        if (!elementRecord) { throw new Error('Empty response'); }
        if (elementRecord.parent != attrs.parentRid) {
          elementRecord.parent = attrs.parentRid;
        }
        elementRecord.permission = ctrl.containsEdge.permission;
        elementRecord.parentRid = attrs.parentRid;
        elementRecord.location = attrs.location;

        ctrl.record(elementRecord);
        ctrl.loading = false;
      })
      .catch(function (error) {
        handleElementLoadError(ctrl, error);
      });
    }
  }


  ctrl.init();
};

function onremove () {
  modal.off('closed', this.init);
}

function onupdate (vnode) {
  var ctrl = this;
  var nextSignature = getChildSignature(vnode.attrs);
  ctrl.attrs = vnode.attrs;
  ctrl.dashboardCallback = vnode.attrs.dashboardCallback;
  ctrl.OrMenuOptions = vnode.attrs.OrMenuOptions;
  ctrl.hidePreferredViewMenu = vnode.attrs.hidePreferredViewMenu;
  ctrl.class = vnode.attrs.class;
  ctrl.datasetRepresentation = vnode.attrs.datasetRepresentation;
  ctrl.expandedCloseIconMargin = vnode.attrs.expandedCloseIconMargin;

  if (nextSignature !== ctrl.childSignature) {
    ctrl.containsEdge = vnode.attrs.child;
    ctrl.childSignature = nextSignature;
    ctrl.init();
  }
}

function view (vnode) {
  var ctrl = this;

  if (ctrl.hidden) {
    return null;
  }
  
  if (ctrl.loading || ctrl.error) {
    // Render a sized placeholder to avoid layout shift while loading
    return placeholder(ctrl, vnode);
  }

  function build (ctrl) {
    var element = ctrl.record();
    var defaultClass = '.fl.w-100.grid-item.mb3.ph3';
    if (element.type !== 'smartTable' && element.type !== 'smartchart') {
      defaultClass += '.overflow-hidden';
    }
    return m('div' + (ctrl.class || defaultClass), {class: getGridClass(element),  rid: ctrl.containsEdge['@rid']}, (function () {
      if (element.type === 'spacer') {
        return builderHeading(ctrl);
      } 
      if (element.type === 'list') {
        const commonProps = {
          dashboardCallback: ctrl.dashboardCallback,
          element: ctrl.record(),
          parentReinitialize: ctrl.init,
          datasetRepresentation: ctrl.datasetRepresentation
        };
        return ctrl.datasetRepresentation ?
          m(datasetBuildingMode, { 
            ...commonProps,
            parentReinitialize: async () => {
              await ctrl.init();
              await ctrl.dashboardCallback();
            },
          })
        :
          m(list, { ...commonProps });
      }
      if (element.type === 'bignumber') {
        return m(bignumber, {key: pointBindingKey(element), element:ctrl.record(), parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback});
      }  
      if (element.type === 'table') {
        return m(table, {element:ctrl.record, parentReinitialize: ctrl.init, OrMenuOptions: ctrl.OrMenuOptions, hidePreferredViewMenu: ctrl.hidePreferredViewMenu, dashboardCallback: ctrl.dashboardCallback });
      }
      if (element.type === 'smartTable') {
        return m(smartTable, {element:ctrl.record, parentReinitialize: ctrl.init, OrMenuOptions: ctrl.OrMenuOptions, hidePreferredViewMenu: ctrl.hidePreferredViewMenu, dashboardCallback: ctrl.dashboardCallback });
      }
      if (element.type === 'smartList') {
        return m(smartList, {element:ctrl.record, parentReinitialize: ctrl.init, OrMenuOptions: ctrl.OrMenuOptions, hidePreferredViewMenu: ctrl.hidePreferredViewMenu, dashboardCallback: ctrl.dashboardCallback });
      }
      if (element.type === 'chart') {
        return m(chart, {key: pointBindingKey(element), element:ctrl.record(), parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback, datasetRepresentation: ctrl.datasetRepresentation});
      } 
      if (element.type === 'smartchart') {
        return m(smartChart, {element:ctrl.record, parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback, expandedCloseIconMargin: ctrl.expandedCloseIconMargin });
      }
      if (element.type === 'chartwithpoint') {
        const commonProps = {
          dashboardCallback: ctrl.dashboardCallback,
          element: ctrl.record(),
          parentReinitialize: ctrl.init,
          datasetRepresentation: ctrl.datasetRepresentation,
          numOfColumns: 1,
          key: pointBindingKey(element)
        };
        return ctrl.datasetRepresentation ?
          m(datasetBuildingMode, { ...commonProps })
        :
          m(chartwithpoint, { ...commonProps });
      }  
      if (element.type === 'chartbyunits') {
        return m(elementChartByUnits, {key: pointBindingKey(element), element:ctrl.record(), parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback});
      }  
      if (element.type === 'tridata') {
        return m(tridata, {key: pointBindingKey(element), element:ctrl.record(), parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback});
      } 
      if (element.type === 'gauge') {
        const commonProps = {
          dashboardCallback: ctrl.dashboardCallback,
          element: ctrl.record(),
          parentReinitialize: ctrl.init,
          datasetRepresentation: ctrl.datasetRepresentation,
          numOfColumns: 1,
          key: pointBindingKey(element)
        };
        return ctrl.datasetRepresentation ?
          m(datasetBuildingMode, { ...commonProps })
        :
          m(gauge, { ...commonProps });        
      } 
      if (element.type === 'linear-gauge') {
        return m(linearGauge, {key: pointBindingKey(element), element:element, parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback});
      }
      if (element.type === 'graphic') {
        return m(graphic, {key: pointBindingKey(element), element:ctrl.record(), parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback});
      }
      if (element.type === 'text') {
        return m(textElement, {element:ctrl.record(), parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback, datasetRepresentation: ctrl.datasetRepresentation});
      }
      if (element.type === 'diagram') {
        return m(diagramElement, { element: ctrl.record(), parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback });
      }
      if (element.type === 'img') {
        return m('div.f3.narrow', [
          m(heading, {
            label: element.name, 
            class: 'f1 mb2', 
            element: ctrl.record(), 
            parentReinitialize: ctrl.init, 
            dashboardCallback: ctrl.dashboardCallback,
            datasetRepresentation: ctrl.datasetRepresentation
          }),
          ctrl.record().srcPath ?
            ctrl.datasetRepresentation ?
              m('img', {src: `/api/v1/dataset/${ctrl.record()['@rid'].slice(1)}/image`})
            : 
              m('img', {src: `/api/v1/element/${ctrl.record()['@rid'].slice(1)}/image`})
          : 
            ''
        ])
      }
    })())
  }

  if (edit.vm.editing()) {
    return build(ctrl);
  } else {
    return browse(ctrl);
  }

};

function browse (ctrl) {
  if (! Array.isArray(ctrl.record().out_Contains)) {
    ctrl.record().out_Contains = [];
  }
  if(ctrl.record().hideInEquipmentDetail && ctrl.record().hideInEquipmentDetail == 'true') {
    return 
  }
  return m('div' + (ctrl.class || `.fl.w-100.ph3.grid-item.mb3${ctrl.record().type != 'smartTable' ? '.overflow-hidden' : ''}`), {class: getGridClass(ctrl.record())}, getComponentType(ctrl));
};

function getGridClass (element) {
  if (!element.width || element.width == 1) {
    return 'w-50-ns w-25-l';
  } else if (element.width == 2) {
    return 'w-50-ns';
  } else if (element.width == 3) {
    return 'w-50-ns w-75-l';
  } else if (element.width == 4) {
    return ''
  } else {
    return '';
  }
}

function pointBindingKey (element) {
  var parts = [element && element['@rid']];
  (Array.isArray(element && element.out_Contains) ? element.out_Contains : []).forEach(function (containsEdge) {
    var dataset = containsEdge && containsEdge.in;
    parts.push(dataset && dataset['@rid']);
    (Array.isArray(dataset && dataset.out_Column) ? dataset.out_Column : []).forEach(function (column) {
      parts.push(column && column['@rid']);
    });
  });
  return parts.filter(Boolean).join('|');
}

function datasetUrlForElement(element) {
  if (!element || !Array.isArray(element.out_Contains)) return null;
  var containsEdge = element.out_Contains[0];
  return containsEdge && containsEdge.in && containsEdge.in.url;
}

function linkedImage(src, url) {
  var image = m('img', {src: src});
  return url ? m('a', {href: url}, image) : image;
}

function getComponentType (ctrl) {
  let element = ctrl.record();
  if (element.type === 'spacer') {
    if (element.dividerType==='blank') { 
      return m('div.w-100.f1.flex.justify-between', [
        element.label,
        element.helpText ?
          m('i.ion-ios-information-outline.white.f1', {
            onclick: () => {
              helpModal.editDialogue(element.name, undefined, element.helpText);
            }
          })
        : ''
      ]); 
    }
    else {
      return m('div.w-100.bb.bw1.f1.flex.justify-between', [
        element.label,
        element.helpText ?
          m('i.ion-ios-information-outline.white.f1', {
            onclick: () => {
              helpModal.editDialogue(element.name, undefined, element.helpText);
            }
          })
        : ''
      ]);
    }
      
  }
  if (element.type === 'list') {
    return m(list, {
      element: element,
      datasetRepresentation: ctrl.datasetRepresentation,
      parentReinitialize: ctrl.init,
      dashboardCallback: ctrl.dashboardCallback
    });
  }
  if (element.type === 'bignumber') {
    return m(bignumber, {element:element});
  }
  if (element.type === 'table') {
    return m(table, {element:ctrl.record, parentReinitialize: ctrl.init, OrMenuOptions: ctrl.OrMenuOptions, hidePreferredViewMenu: ctrl.hidePreferredViewMenu });
  }
  if (element.type === 'smartTable') {
    return m(smartTable, {element:ctrl.record, parentReinitialize: ctrl.init, OrMenuOptions: ctrl.OrMenuOptions, hidePreferredViewMenu: ctrl.hidePreferredViewMenu });
  }
  if (element.type === 'smartList') {
    return m(smartList, {element:ctrl.record, parentReinitialize: ctrl.init, OrMenuOptions: ctrl.OrMenuOptions, hidePreferredViewMenu: ctrl.hidePreferredViewMenu });
  }
  if (element.type === 'chart') {
    return m(chart, {key: pointBindingKey(element), element:element, datasetRepresentation: ctrl.datasetRepresentation});
  } 
  if (element.type === 'smartchart') {
    return m(smartChart, {element:ctrl.record, parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback, expandedCloseIconMargin: ctrl.expandedCloseIconMargin });
  }
  if (element.type === 'chartwithpoint') {
    return m(chartwithpoint, {element:element, datasetRepresentation: ctrl.datasetRepresentation});
  } 
  if (element.type === 'chartbyunits') {
    return m(elementChartByUnits, {element:element});
  } 
  if (element.type === 'tridata') {
    return m(tridata, {element:element});
  }  
  if (element.type === 'gauge') {
    return m(gauge, {key: pointBindingKey(element), element:element, datasetRepresentation: ctrl.datasetRepresentation});
  }
  if (element.type === 'gauge-accum') {
    return m(gaugeAccum, {element:element});
  }
  if (element.type === 'linear-gauge') {
    return m(linearGauge, {element:element});
  }
  /*if (element.type === 'schedule') {
    return m(schedule, {element:element});
  }*/
  if (element.type === 'img') {
    var imageSrc = ctrl.datasetRepresentation ?
      `/api/v1/dataset/${element['@rid'].slice(1)}/image`
    :
      `/api/v1/element/${element['@rid'].slice(1)}/image`;
    var imageUrl = ctrl.datasetRepresentation ? datasetUrlForElement(element) : null;

    return m('div.f3', [
      m(heading, {
        label: element.name,
        class: 'f1 mb2',
        element: element,
        parentReinitialize: ctrl.init,
        dashboardCallback: ctrl.dashboardCallback,
        datasetRepresentation: ctrl.datasetRepresentation
      }, [
        element.helpText ?
          m('i.ion-ios-information-outline.white.f1.ml2', {
            onclick: () => {
              helpModal.editDialogue(element.name, undefined, element.helpText);
            }
          })
        : ''
      ]),
      element.srcPath ?
        linkedImage(imageSrc, imageUrl)
      : 
        ''
    ])
  }
  if (element.type === 'graphic') {
    return m(graphic, {element:element});
  }
  if (element.type === 'text') {
    return m(textElement, {element:ctrl.record(), parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback});
  }
  if (element.type === 'diagram') {
    return m(diagramElement, { element: ctrl.record(), parentReinitialize: ctrl.init, dashboardCallback: ctrl.dashboardCallback });
  }
}

function builderHeading (ctrl) {
  return m('div.h2.f1.bb.bw1.flex.justify-between.items-center.narrow.grid-item-drag-handle', {style:{cursor: 'grab'}}, [
    m('span.blue', {
      onclick: ctrl.datasetRepresentation ? 
          datasetForm.editDialogue.bind(datasetForm, ctrl.record(), {delete:'true', dashboardCallback: ctrl.dashboardCallback, submitCallback: ctrl.init })
        : 
          elementForm.editDialogue.bind(elementForm, ctrl.record(), {delete:'true', dashboardCallback: ctrl.dashboardCallback, submitCallback: ctrl.init})
    }, ctrl.record().type == 'spacer' && ctrl.record().label ? ctrl.record().label : ctrl.record().name ? ctrl.record().name : m('i.ion-ios-compose.blue')),
  ])
}

module.exports = {oninit: oninit, view: view, onremove: onremove, onupdate: onupdate};

// Helpers
function placeholder(ctrl, vnode) {
  const edge = ctrl.containsEdge || {};
  const el = (edge && edge.in) || {};
  const type = el.type || 'list';
  const widthClass = getGridClass(el);
  const isSmartTable = type === 'smartTable';
  const containerSelector = ctrl.class || `.fl.w-100.grid-item.mb3.ph3${!isSmartTable ? '.overflow-hidden' : ''}`;

  // Allow parent to hint height via attrs
  const hintedHeight = vnode && vnode.attrs && vnode.attrs.estimatedHeight;
  const rowsHint = vnode && vnode.attrs && vnode.attrs.estimatedRows;

  const minHeight = hintedHeight || estimateHeight(type, el, rowsHint);

  // Simple skeleton: header bar + content blocks (static blocks; shimmer runs on container)
  const headerBar = type !== 'spacer'
    ? (type === 'list'
        ? m('div.flex.items-center.justify-between.mb2', [
            m('div.f1.white', (el && el.name) ? el.name : ''),
            m('div.br2.bg-dark-gray.o-30', { style: { height: '14px', width: '10%' } })
          ])
        : m('div.flex.items-center.justify-between.mb2', [
            m('div.br2.bg-dark-gray.o-30', { style: { height: '18px', width: '60%' } }),
            m('div.br2.bg-dark-gray.o-30', { style: { height: '14px', width: '10%' } })
          ])
      )
    : null;

  const content = (() => {
    if (['chart', 'smartchart', 'chartwithpoint', 'chartbyunits', 'graphic', 'gauge', 'linear-gauge', 'img', 'diagram'].includes(type)) {
      return m('div.br2.bg-dark-gray.o-20', { style: { height: Math.max(120, minHeight - 24) + 'px' } });
    }
    if (type === 'bignumber') {
      return m('div.br2.bg-dark-gray.o-20', { style: { height: Math.max(72, minHeight - 24) + 'px', width: '50%' } });
    }
    if (type === 'spacer') {
      return m('div.br2.bg-dark-gray.o-20', { style: { height: minHeight + 'px', width: '30%' } });
    }

    // Structured skeleton for list: mimic two-column table
    if (type === 'list') {
      const rows = rowsHint || defaultRows(type);
      const bodyRows = [];
      for (let r = 0; r < rows; r++) {
        const leftWidth = 70 - (r % 3) * 10;  // vary left label width
        const rightWidth = 55 - (r % 2) * 10; // vary right value width
        bodyRows.push(
          m('tr.bb', [
            m('td.f3.man.bb.tl.moon-gray.w-50', [
              m('div.f3.br2.bg-dark-gray.o-20', { style: { height: '1em', width: leftWidth + '%' } })
            ]),
            m('td.f3.man.bb.tl.moon-gray.w-50', [
              m('div.f3.br2.bg-dark-gray.o-20', { style: { height: '1em', width: rightWidth + '%' } })
            ])
          ])
        );
      }
      return m('table.w-100', { style: { tableLayout: 'fixed' } }, [
        m('tbody', bodyRows)
      ]);
    }

    // Specialized skeleton for tables
    if (type === 'table' || type === 'smartTable') {
      const rows = rowsHint || Number(el && el.rowLimit) || defaultRows(type);
      const cols = 5; // dataset name + ~4 value columns as a safe default
      const headerCells = [];
      // First header cell (dataset label)
      const title = (el && el.name) ? String(el.name) : '';
      const titleChWidth = Math.max(8, Math.min(40, title.length + 2)); // fit-to-title width
      const otherColWidth = Math.max(10, Math.floor((100 - 5) / (cols - 1))); // keep others reasonable
      headerCells.push(
        m('th.tl.bb.b--mid-gray.pr3', { style: { width: titleChWidth + 'ch', whiteSpace: 'nowrap' } }, [
          m('div.flex.items-end.f1.fw5', [
            m('span', el && el.name ? el.name : ''),
          ])
        ])
      );
      for (let c = 1; c < cols; c++) {
        headerCells.push(
          m('th.tc.bb.b--mid-gray', { style: { width: otherColWidth + '%' } }, [
            m('div.br2.bg-dark-gray.o-30.center', { style: { height: '12px', width: '50%' } })
          ])
        );
      }
      const bodyRows = [];
      for (let r = 0; r < rows; r++) {
        const cells = [];
        // Dataset/name cell
        cells.push(
          m('td.bb.moon-gray.tl.nowrap.pr3.overflow-hidden', { style: { width: titleChWidth + 'ch', whiteSpace: 'nowrap' } }, [
            m('div.f4.br2.bg-dark-gray.o-20', { style: { height: '1em', width: '70%' } })
          ])
        );
        for (let c = 1; c < cols; c++) {
          const w = 70 - ((r + c) % 3) * 10; // vary widths a bit
          cells.push(
            m('td.bb.bl-0', { style: { width: otherColWidth + '%' } }, [
              m('div.f4.br2.bg-dark-gray.o-20.center', { style: { height: '1em', width: w + '%' } })
            ])
          );
        }
        bodyRows.push(m('tr', cells));
      }
      const minTableWidth = Math.max(480, (cols + 1) * 120); // ensure non-zero width
      return m('div.dragscroll-container', [
        m('div.dragscroll', [
          m('table.fw2.f3.pr4.pb3.narrow', { style: { tableLayout: 'fixed', width: '100%', minWidth: minTableWidth + 'px' } }, [
            m('thead', [ m('tr', headerCells) ]),
            m('tbody', bodyRows)
          ])
        ])
      ]);
    }

    // list, tridata, text → row blocks
    const rows = rowsHint || defaultRows(type);
    const blocks = [];
    for (let i = 0; i < rows; i++) {
      const w = 70 - (i % 3) * 10; // vary widths a bit
      blocks.push(
        m('div.f4.br2.bg-dark-gray.o-20.mb1', { style: { height: '1em', width: w + '%' } })
      );
    }
    return m('div', blocks);
  })();

  const containerClasses = widthClass + (ctrl.error ? ' is-error' : '') + (ctrl.loading && !ctrl.error ? ' skeleton' : '');
  return m('div' + containerSelector, { class: containerClasses, style: { position: 'relative' }, 'aria-busy': ctrl.error ? 'false' : 'true', 'aria-label': ctrl.error ? 'Error' : 'Loading' }, [
    m('div.pa2', { style: { minHeight: minHeight + 'px', width: '100%' } }, [
      headerBar,
      m('div.relative', [
        content,
        ctrl.error ?
          m('div.absolute.top-0.left-0.right-0.bottom-0.flex.items-center.justify-center', { style: { background: 'rgba(0,0,0,0.25)' } }, [
            m('div.tc.white.ph3.pv3', { style: { background: 'rgba(0,0,0,0.55)', borderRadius: '6px' } }, [
              m('i.ion-alert-circled.yellow.f1.db.mb2'),
              m('div.f4', 'Error')
            ])
          ])
        : null
      ])
    ])
  ]);
}

function estimateHeight(type, el, rowsHint) {
  if (el && el.height) return Number(el.height) || 0;
  switch (type) {
    case 'chart':
    case 'chartwithpoint':
    case 'chartbyunits':
      return 300;
    case 'gauge':
    case 'linear-gauge':
      return 220;
    case 'graphic':
    case 'img':
    case 'diagram':
      return 240;
    case 'bignumber':
      return 100;
    case 'tridata':
      return 120;
    case 'text':
      return 140;
    case 'spacer':
      return 48;
    case 'smartTable':
    case 'table':
    case 'list':
    default: {
      // Prefer an explicit row limit if present on element
      const rows = rowsHint || Number(el && el.rowLimit) || defaultRows(type);
      const header = 40; // approx header height
      const row = 22;    // approx line-height
      return header + rows * row;
    }
  }
}

function defaultRows(type) {
  if (type === 'tridata') return 3;
  if (type === 'bignumber') return 1;
  return 6;
}
